import React, { useEffect, useRef, useState } from "react";
import QRCode from "qrcode";

const QRGenerator = ({ employee }) => {
  const canvasRef = useRef(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;

    const draw = async () => {
      setError("");
      if (!employee?.qrCode || !canvasRef.current) return;

      try {
        await QRCode.toCanvas(canvasRef.current, employee.qrCode, {
          width: 220,
          margin: 2,
          errorCorrectionLevel: "M",
        });
      } catch (err) {
        if (!cancelled) {
          setError("No se pudo generar el QR.");
          console.error(err);
        }
      }
    };

    draw();
    return () => {
      cancelled = true;
    };
  }, [employee.qrCode]);

  return (
    <div className="w-full max-w-md mx-auto p-8 glass-card rounded-2xl shadow-2xl border-slate-800/80 text-center relative overflow-hidden flex flex-col items-center">
      <div className="absolute top-0 right-0 w-32 h-32 bg-cyan-500/5 rounded-full blur-3xl -z-10"></div>
      <div className="absolute bottom-0 left-0 w-32 h-32 bg-indigo-500/5 rounded-full blur-3xl -z-10"></div>

      <h3 className="text-xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-slate-100 to-slate-300">
        Credencial QR de {employee.nombre}
      </h3>
      
      <div className="p-4 bg-white rounded-2xl shadow-inner border border-slate-200/20 mb-6 flex justify-center items-center">
        <canvas ref={canvasRef} className="rounded-lg" />
      </div>

      {error && (
        <div className="p-2 bg-rose-500/10 text-rose-400 text-xs rounded-lg border border-rose-500/25 mb-4 w-full">
          {error}
        </div>
      )}

      <div className="w-full space-y-2 mb-8">
        <div className="flex justify-between items-center py-2 border-b border-slate-900">
          <span className="text-xs text-slate-500 uppercase tracking-wider font-semibold">Empleado</span>
          <span className="text-sm text-slate-300 font-medium">{employee.nombre} {employee.apellidos}</span>
        </div>
        <div className="flex justify-between items-center py-2 border-b border-slate-900">
          <span className="text-xs text-slate-500 uppercase tracking-wider font-semibold">DNI</span>
          <span className="text-sm text-slate-300 font-mono font-medium">{employee.dni}</span>
        </div>
        <div className="flex justify-between items-center py-2">
          <span className="text-xs text-slate-500 uppercase tracking-wider font-semibold">Código Interno</span>
          <span className="text-xs text-cyan-400 font-mono tracking-tight">{employee.qrCode}</span>
        </div>
      </div>

      <button
        className="w-full py-3 bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-400 hover:to-blue-500 text-white font-semibold rounded-xl shadow-lg shadow-cyan-500/10 hover:shadow-cyan-500/20 hover:-translate-y-0.5 transition-all duration-200"
        onClick={() => {
          const canvas = canvasRef.current;
          if (canvas) {
            const link = document.createElement("a");
            link.download = `qr-${employee.dni}.png`;
            link.href = canvas.toDataURL("image/png");
            link.click();
          }
        }}
      >
        Descargar Credencial QR
      </button>
    </div>
  );
};

export default QRGenerator;
